import * as Yup from "yup";

const validationSchema = [
  Yup.object().shape({
    Name: Yup.string()
      .trim()
      .matches(/^[a-zA-Z0-9 ']+$/, "Incorrect format")
      .max(100, "Must be 100 characters or less")
      .required("Required"),
    Address: Yup.object().shape({
      Street: Yup.string().trim().matches(/^[a-zA-Z0-9.\s]+$/,"Incorrect format").max(100,"Must be 100 characters or less").required("Required"),
      City: Yup.string().trim().matches(/^[a-zA-Z\s]+$/,"Incorrect format").max(50,"Must be 50 characters or less").required("Required"),
      Additional: Yup.string().trim().matches(/^[a-zA-Z0-9().,\s"-]*$/,"Incorrect format").max(200,"Must be 200 characters or less"),
      Zip: Yup.string().trim().matches(/^([0-9]{5}(?:-[0-9]{4})?)?$/, "Zip code format is 00000-0000"),
      CountryCode: Yup.string().trim().required("Required"),
    }),
    Coordinate: Yup.object().shape({
      Latitude: Yup.number().required("Required"),
      Longitude: Yup.number().required("Required"),
    }),
    Timezone: Yup.string()
      .trim()
      .required("Required")
  }),
  Yup.object().shape({
    Calendar: Yup.object().shape({
      Daysinfo: Yup.object().shape({
        Monday: Yup.array().of(
          Yup.object().shape({
              TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
              TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
          })
        ),
        Tuesday: Yup.array().of(
          Yup.object().shape({
              TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
              TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
          })
        ),
        Wednesday: Yup.array().of(
          Yup.object().shape({
              TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
              TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
          })
        ),
        Thursday: Yup.array().of(
          Yup.object().shape({
              TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
              TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
          })
        ),
        Friday: Yup.array().of(
          Yup.object().shape({
              TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
              TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
          })
        ),
        Saturday: Yup.array().of(
          Yup.object().shape({
              TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
              TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
          })
        ),
        Sunday: Yup.array().of(
          Yup.object().shape({
              TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
              TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
          })
        ),
      }),
    }),
  }),
  Yup.object().shape({
    Contact: Yup.object().shape({
      Emails: Yup.array().required("Required")
        .transform(function (value, originalValue) {
          if (this.isType(value) && value !== null) {
            return value;
          }
          return originalValue ? originalValue.split(/[\s,]+/) : [];
        })
        .of(Yup.string().email(({ value }) => `"${value}" is not a valid email. `)),
      Website: Yup.string()
        .trim()
        .matches(
          /^[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/,
          "Incorrect format"
        )
        .required("Required"),
      Phones: Yup.array().of(Yup.string().trim().matches(/^\+(?:[0-9] ?){6,14}[0-9]$/, "Incorrect format"))

    }),
  }),
  Yup.object().shape({
    Services: Yup.array().of(
      Yup.object().shape({
        Service: Yup.string().trim().matches(/^[a-zA-Z0-9.\s]+$/,"Wrong format").required("Required"),

        Active: Yup.boolean().required("Required"),
      })
    ),
  }),
];

export default validationSchema;
